import { Action } from '@ngrx/store';
import { CustomerInterface } from '../../models/customer.interface';
import { UpdatePasswordInterface } from '../../models/update-password.interface';
import { MfaInterface } from '../../../shared/models/mfa.interface';

export enum ECustomerActions {
  GetCustomer = '[CUSTOMER] Get customer',
  GetCustomerSuccess = '[CUSTOMER] Get customer success',
  GetCustomerFailure = '[CUSTOMER] Get customer failure',
  UpdateBillingAddress = '[CUSTOMER] Update billing customer',
  UpdatePersonnelInformationCustomer = '[CUSTOMER] Update personnel information customer',
  UpdateCustomerSuccess = '[CUSTOMER] Update customer success',
  UpdateCustomerFailure = '[CUSTOMER] Update customer failure',
  DeleteCustomer = '[CUSTOMER] Delete customer',
  DeleteCustomerSuccess = '[CUSTOMER] Delete customer success',
  UpdatePassword = '[CUSTOMER] Update password',
  UpdatePasswordFailure = '[CUSTOMER] Update password failure',
  UpdatePasswordSuccess = '[CUSTOMER] Update password success',
}

/**
 * Set get customer action and state to save in store
 */
export class GetCustomer implements Action {
  public readonly type = ECustomerActions.GetCustomer;
}

/**
 * Set get customer success action and state to save in store
 */
export class GetCustomerSuccess implements Action {
  public readonly type = ECustomerActions.GetCustomerSuccess;
  // payload : request http to save in store, will be saved by the reducer
  constructor(public payload: CustomerInterface) {}
}

/**
 * Set get customer failure action and state to save in store
 */
export class GetCustomerFailure implements Action {
  public readonly type = ECustomerActions.GetCustomerFailure;
}

/**
 * Set update customer billing address action and state to save in store
 */
export class UpdateBillingAddress implements Action {
  public readonly type = ECustomerActions.UpdateBillingAddress;
  // payload passed as param and will be used by the effect
  constructor(
      public payload: CustomerInterface,
      public mfa: MfaInterface|null = null
  ) {}
}

/**
 * Set update customer action and state to save in store
 */
export class UpdatePersonnelInformationCustomer implements Action {
  public readonly type = ECustomerActions.UpdatePersonnelInformationCustomer;
  // payload passed as param and will be used by the effect
  constructor(
      public payload: CustomerInterface,
      public mfa: MfaInterface|null = null
  ) {}
}

/**
 * Set update customer action and state to save in store
 */
export class UpdateCustomerSuccess implements Action {
  public readonly type = ECustomerActions.UpdateCustomerSuccess;
}

/**
 * Set update customer action failure and state to save in store
 */
export class UpdateCustomerFailure implements Action {
  public readonly type = ECustomerActions.UpdateCustomerFailure;
}

/**
 * Set delete customer action and state to save in store
 */
export class DeleteCustomer implements Action {
  public readonly type = ECustomerActions.DeleteCustomer;
}

/**
 * Set delete customer success action and state to save in store
 */
export class DeleteCustomerSuccess implements Action {
  public readonly type = ECustomerActions.DeleteCustomerSuccess;
}

/**
 * Set update password action and state to save in store
 */
export class UpdatePassword implements Action {
  public readonly type = ECustomerActions.UpdatePassword;
  // payload passed as param and will be used by the effect
  constructor(
      public payload: UpdatePasswordInterface,
      public mfa: MfaInterface|null = null
  ) {}
}

/**
 * Set update password action and state to save in store
 */
export class UpdatePasswordSuccess implements Action {
  public readonly type = ECustomerActions.UpdatePasswordSuccess;
}

/**
 * Set update password action failure and state to save in store
 */
export class UpdatePasswordFailure implements Action {
  public readonly type = ECustomerActions.UpdatePasswordFailure;
}

/**
 * Export actions : will be used in reducers
 */
export type CustomerActions = UpdatePersonnelInformationCustomer | GetCustomer | GetCustomerSuccess | UpdateBillingAddress | UpdateCustomerSuccess | UpdateCustomerFailure | DeleteCustomer | DeleteCustomerSuccess | UpdatePassword| UpdatePasswordSuccess | UpdatePasswordFailure;
